import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';
import { Store } from '@ngxs/store';
import { SetColorRecipe, ClearColorRecipe } from 'src/app/edit/state/paint/edit.paint.actions';
import { EditPaintState } from 'src/app/edit/state/paint/edit.paint.state';
import { ColorService } from 'src/app/shared/color.service';
import { ToolEnum } from 'src/app/engine/models/tool.enum';
import { SetActiveTool } from 'src/app/engine/state/engine.actions';
import { PaintPresets } from 'src/app/engine/models/paint-presets.const';

import * as _ from 'lodash';

@Component({
  selector: 'app-paint-presets',
  templateUrl: './paint-presets.component.html',
  styleUrls: ['./paint-presets.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaintPresetsComponent implements OnInit {
  name = '';
  presets = PaintPresets;

  groupedPresets = _.chain(this.presets)
    .groupBy('group')
    .reduce((result, value, key) => {
      result.push({
        label: key,
        items: value
      });
      return result;
    }, [])
    .valueOf();

    

  constructor(
    private store: Store
  ) { }

  ngOnInit() {
  }

  handleRecipeClick(colorRecipe: ColorRecipeModel) {
    this.store.dispatch(new ClearColorRecipe());
    this.store.dispatch(new SetColorRecipe(colorRecipe));
    this.store.dispatch(new SetActiveTool(ToolEnum.Paint));
  }


  isSelected(colorRecipe) {
    const selectedRecipe = this.store.selectSnapshot(EditPaintState.getColorRecipe);
    return JSON.stringify(colorRecipe) === JSON.stringify(selectedRecipe);
  }

}


